import api from '../../services/api';
import {useQuery} from "react-query";
import queryClient from "../../services/queryClient";

/*
 * Timing tiers
 */
const fetchTimingTiers = (slug) => api.get(`timings/${slug}/tiers`).then(res => res?.data?.data);

export const useFetchTimingTiers = (slug) => {
    return useQuery(['timing.tiers', slug], () => fetchTimingTiers(slug), {
        enabled: !!slug,
    });
}


/*
 * Fetch timing
 */

const fetchTiming = (slug) => api.get(`timings/${slug}`).then(res => {
    const data = res?.data?.data;

    if(data) {
        data.valid = res?.data?.valid || false;
        data.expires_at = res?.data?.expires_at || null;
    }

    return data;
});

const useFetchTiming = (slug) => {
    return useQuery(['timings', slug], () => fetchTiming(slug), {
        enabled: !!slug,
        onSuccess: (data) => {
            queryClient.setQueryData(['valid', data.id], !!data.valid);
        }
    });
}

export default useFetchTiming;
